import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=7169278e&scoped=true&"
import script from "./Dialogs.vue?vue&type=script&lang=ts&"
export * from "./Dialogs.vue?vue&type=script&lang=ts&"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=7169278e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7169278e",
  null
  
)

export default component.exports